import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTopHandler = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
